import { createFileRoute } from '@tanstack/react-router';
import { CommessaSheet } from '@/pages/commesse/form/commessa-sheet';
import { PROTECTED, COMMESSE } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${COMMESSE}`;

export const Route = createFileRoute('/protected/_layout/commesse/_layout/$id')(
  {
    ...createSheetRouteOptions(RETURN_URL),
    component: () => {
      const { id } = Route.useParams();
      return <CommessaSheet id={id} returnUrl={RETURN_URL} />;
    },
  }
);
